import React from "react";
import { useNavigate } from "react-router-dom";
import "./offcanvas.css";

export const CartOff = ({
  offcanvasRef,
  cart,
  updateCart,
  deleteCart,
  totals,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div
        ref={offcanvasRef}
        className="offcanvas offcanvas-end"
        tabIndex="-1" // ✅ fixed: tabindex → tabIndex
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            My Products
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        {Array.isArray(cart) && cart.length > 0 && (
          <div className="offcanvas-body">
            {cart.map((x) => (
              <React.Fragment key={x?.id}>
                {" "}
                {/* ✅ fixed: key moved to Fragment */}
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={`${process.env.REACT_APP_ASSET_URL}/${x?.Product?.image}`}
                    alt="Product Image"
                    className="product-image me-3"
                  />
                  <div>
                    <div className="product-name">{x?.Product?.name}</div>
                    <div className="d-flex align-items-center mt-2">
                      <div className="quantity-container">
                        <button
                          className="quantity-button"
                          id="decrement"
                          onClick={() => {
                            if (x?.quantity > 1) {
                              updateCart({
                                id: x?.id,
                                quantity: parseInt(x?.quantity) - 1,
                              });
                            }
                          }}
                        >
                          -
                        </button>
                        <input
                          type="number"
                          id="quantity"
                          className="quantity-input"
                          value={x?.quantity}
                          min="0"
                          readOnly // ✅ fixed: added readOnly
                        />
                        <button
                          className="quantity-button"
                          id="increment"
                          onClick={() => {
                            if (x?.quantity < 10) {
                              updateCart({
                                id: x?.id,
                                quantity: parseInt(x?.quantity) + 1,
                              });
                            }
                          }}
                        >
                          +
                        </button>
                      </div>
                      <div className="product-price">
                        ₹ {x?.Product?.currentPrice}
                      </div>
                      <div style={{ marginLeft: "10px" }}>
                        <i
                          className="fa fa-trash"
                          style={{ color: "red", cursor: "pointer" }}
                          onClick={() => deleteCart(x?.id)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </React.Fragment>
            ))}

            <div className="order-summary">
              <h5>Order Summary</h5>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>Products:</p>
                <p>{totals?.totalQuantity}</p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p>Retail Price:</p>
                <p>₹{totals?.totalPrice}</p>
              </div>
            </div>

            <div className="checkout-buttons">
              <button
                className="btn btn-checkout mb-3"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={() => navigate("/checkout")}
              >
                CHECKOUT
              </button>
              <button
                className="btn btn-continue-shopping"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                CONTINUE SHOPPING
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
